<template>
  <ApolloMutation :mutation="(gql) => updateConnectorQuery">
    <template v-slot="{ mutate, loading }">
      <v-container>
        <v-row no-gutters align="center" justify="center">
          <v-col sm="10">
            <v-select
              v-model="chapter"
              :items="chapters"
              item-value="id"
              label="Chapter Title"
              :loading="loading"
              :disabled="loading"
              return-object
              single-line
              hide-details
              solo
              dense
              class="mt-d1"
              @change="
                mutate({
                  refetchQueries: ['GetStoryWithChapters'],
                  variables: {
                    toChapterId: $event.id,
                    chapterConnectorId: connection.id,
                  },
                })
              "
            >
              <template v-slot:item="data">
                {{ getName(data.item.name) }}
              </template>
              <template v-slot:selection>
                {{ getName(chapter.name) }}
              </template>
            </v-select>
          </v-col>
          <v-col sm="2">
            <DeleteConnection
              :connectionId="connection.id"
              :chapterId="chapterId"
              :storyId="storyId"
            />
          </v-col>
        </v-row>
      </v-container> </template
  ></ApolloMutation>
</template>
<script>
import { chapterQueries } from "@/graphql/ChapterQueries";
import DeleteConnection from "./DeleteConnection";
export default {
  components: {
    DeleteConnection,
  },
  data() {
    return {
      chapter: this.connection ? this.connection.toChapter : {},
    };
  },
  props: {
    connection: Object,
    chapters: Array,
    chapterId: String,
    storyId: String,
  },
  methods: {
    getName(name) {
      if (name != "") {
        return name;
      }
      return "[" + this.$t("chapter.noTitle") + "]";
    },
  },
  computed: {
    updateConnectorQuery() {
      return chapterQueries.updateChapterConnector;
    },
  },
};
</script>
